import request from "@/request";
export const get_order_list=(params)=>request.get(`/api/admin/orders/`,{params})
export const get_only=(id)=>request.get(`/api/admin/orders/${id}/`)
export const del_order=(id)=>request.delete(`/api/admin/orders/${id}/`)